/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'

import styles from './EmuContributionBlockedBanner.module.css'

export const EmuContributionBlockedBanner = () => {
  return (
    <Flash
      variant={'warning'}
      data-jump-to-bottom-target
      tabIndex={-1}
      id="emu-contribution-blocked-banner"
      className={styles.contributionBlockedBanner}
    >{`You cannot contribute to repositories outside of your enterprise.`}</Flash>
  )
}
